const Space = ({ width, height }) => {
  return <div style={{ width, height }} />
}
export default Space
